import { React } from 'react'
import { motion } from 'framer-motion'

import './Agency.scss'

import { useDocumentTitle, useDocumentConfig } from 'hooks/useDocument'

import Hero from 'modules/Hero'
import Button from 'components/Button'
import ServicePicto from 'components/ServicePicto'

import BIGetNouf from '../images/big_et_nouf.jpg'
import Francois from '../images/profil_francois.jpg'
import Marion from '../images/profil_marion.jpg'

const Agency = () => {
	useDocumentTitle(`À propos`)
	useDocumentConfig(`orange`, false)

	return (
		<motion.main
			className='agency'
			initial={{ opacity: 0, transition: { duration: 0.3 } }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0, transition: { duration: 0.3 } }}
		>
			<Hero
				scene={2}
				scrollTo='Qui se cache derrière BIG et Nouf ?'
			>
				Votre agence web<br />
				à Arras.
			</Hero>

			<section className='agency-presentation columns'>
				<div className='column-half'>
					<h2>Votre agence web à Arras, à proximité de Lille, au coeur de la région Hauts-de-France</h2>
					<p>
						Votre partenaire de confiance pour la création de sites web et d'applications sur mesure, la TMA, le développement sur divers CMS, et bien plus encore. Nous prenons plaisir à fournir des solutions web exceptionnelles pour répondre à vos besoins.
					</p>
					<span className='picto-container mobile-margin-bottom'>
						<ServicePicto
							version="techniques"
							size="big"
						/>
					</span>
					<Button
						to={`${process.env.PUBLIC_URL}/nous-contacter`}
						version='2'
					>
						On en parle&nbsp;?
					</Button>
				</div>
				<div className='column-half align-right mobile-hide'>
					<picture>
						<img
							src={BIGetNouf}
							alt=''
						/>
					</picture>
				</div>
			</section>

			<section className='agency-mdournel columns'>
				<div className='column-half align-left mobile-align-center mobile-second'>
					<picture>
						<img
							src={Marion}
							alt='Marion Dournel'
						/>
					</picture>
				</div>
				<div className='column-half align-left mobile-margin-bottom mobile-first'>
					<h2>Marion Dournel alias Nouf</h2>
					<p>Marion, c’est la partie créative et pleine d’idée de l’agence&nbsp;!</p>
					<p>À l'écoute, imaginative et rêveuse, elle vous fera des propositions aux petits oignons, qui feront prendre une autre hauteur à vos projets numériques.</p>
					<p>Son petit plus&nbsp;? Sa sensibilité toute particulière aux projets artistiques et tournés vers l'humain.</p>
					<p><strong>Développeuse, co-gérante</strong></p>
				</div>
			</section>

			<section className='agency-fbeaumont columns align-left'>
				<div className='column-half align-left mobile-margin-bottom mobile-first'>
					<h2>François Beaumont alias BIG</h2>
					<p>François, c’est la structure et l’expertise de l’agence&nbsp;!</p>
					<p>Développeur senior passionné par le développement front-end, il met un point d'honneur à soigner chaque détail.<br />En résumé&nbsp;? Il créé les web apps interactives qu’il vous faut, quels que soient les défis techniques.</p>
					<p>Son petit plus&nbsp;? Son intérêt marqué pour l'intelligence artificielle et les modèles génératifs.</p>
					<p><strong>Développeur, co-gérant</strong></p>
				</div>
				<div className='column-half align-right mobile-align-center mobile-second'>
					<picture>
						<img
							src={Francois}
							alt='François Beaumont'
						/>
					</picture>
				</div>
			</section>
		</motion.main>
	)
}

export default Agency
